<div style="width: 794px; margin: 0 auto; border: 1px solid #000; padding: 30px; font-family: 'Devanagari', sans-serif; font-size: 14px; line-height: 1.6;">

        <!-- <button class="noPrint" style="margin-top: 2%;" mat-raised-button color="primary" [useExistingCss]="true"
            printSectionId="print-section" ngxPrint>
            print
        </button> -->
       <button class="noPrint" style="margin-top: 2%; margin-left: 2%" mat-raised-button color="primary" (click)="saveChallan()">
  Save
</button>

        <!-- <button *ngIf="isupdate == true" class="noPrint" style="margin-top: 2%; margin-left: 2%" (click)="updateInvoice()" mat-raised-button
            color="primary">
            Update
        </button> -->
        <!-- <button class="noPrint" style="margin-top: 2%" mat-button mat-dialog-close>
            Close
        </button> -->
       
  <!-- Header -->
  <div style="display: flex; justify-content: space-between; align-items: flex-start;">
    <div>
      <div>हिंदुस्थान प्रकाशन संस्था 303, वडाळा उद्योग भवन, नायगाव</div>
      <div>क्रोश रोड, वडाळा, मुंबई 400 031 दूरध्वनी: 9967570531</div>
    </div>
    <div>
      <img src="../../../assets/img/brand/red.png" alt="Vivek Logo"
        style="height: 150px;margin-top: 10px; margin-left: auto;" />
    </div>
  </div>

  <!-- Space -->
  <div style="height: 20px;"></div>

  <!-- Recipient & Date -->
  <div style="display: flex; justify-content: space-between;">
    <div>
      प्रति,<br />
      <div class="col-7 bottom right flexbox">
        <span class="heading1 alignment"><strong>नाव:</strong> {{ showData.distribution_representative }}</span><br />
        <span class="alignment"><strong>पत्ता:</strong> {{ showData.address }}</span><br />
        <span><strong>राज्य:</strong> {{ showData.state }}</span><br />
        <span><strong>पिनकोड:</strong> {{ showData.pincode }}</span><br />
        <span><strong>मोबाइल:</strong> {{ showData.mobile_no }}</span>
      </div>
    </div>
    <div>
      <strong>दिनांक:</strong> {{ currentDate }}
    </div>
  </div>

  <!-- Table -->
  <table style="width: 100%; border: 1px solid black; border-collapse: collapse; margin-top: 30px;">
    <thead>
      <tr>
        <th style="border: 1px solid black; padding: 8px; text-align: center;">अंक संख्या</th>
        <th style="border: 1px solid black; padding: 8px; text-align: center;">रक्कम</th>
        <th style="border: 1px solid black; padding: 8px; text-align: center;">गणीबंडल</th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td style="border: 1px solid black; padding: 8px; text-align: center;">{{ showData.copies }}</td>
        <td style="border: 1px solid black; padding: 8px; text-align: center;">{{ showData.totalamount }}</td>
        <td style="border: 1px solid black; padding: 8px;"></td>
      </tr>
    </tbody>
  </table>

  <!-- Footer -->
  <div style="margin-top: 40px; text-align: right;">
    <strong>(वर्गणी व विक्री विभाग)</strong>
  </div>

  <hr style="margin: 30px 0;" />

  <div style="text-align: center;">
    मुख्य कार्यालय : 12, कामत औद्योगिक वसाहत, 316, स्वा वीर सावरकर मार्ग, प्रभादेवी, मुंबई - 400025 <br />
    <span>दूरध्वनी: 9976570531, Email: vivekwklvargani&#64;gmail.com</span>
  </div>
</div>
